import { Component, Injectable, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';

import { CommonService } from "../../../_common/_service/user.service";
import { AuthenticationService } from '../../../_common/_service/authentication.service';
import { BeforePaymentConfirmDialogComponent } from '../../popup/beforepayment-confirm-dialog/beforepayment-confirm-dialog.component';
import { DatePipe, formatDate } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';

export const PICK_FORMATS = {
  parse: { dateInput: { month: 'short', year: 'numeric', day: 'numeric' } },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' }
  }
};

@Injectable()
class PickDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      return formatDate(date, 'dd-MM-yyyy', this.locale);
    } else {
      return date.toDateString();
    }
  }
}

@Component({
  selector: 'app-beneficiarybanktransfer',
  templateUrl: './beneficiarybanktransfer.component.html',
  styleUrls: ['./beneficiarybanktransfer.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: PickDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS }
  ]
})

export class BeneficiaryBanktransferComponent implements OnInit {

  userorderdetailList: any;
  stringJson: any;
  stringObject: any;
  submitted = false;
  countryCode: any;
  channelList: any;
  balance: any;
  ServiceName: any;
  cUser: any;
  finalAmount: any;
  commissionFee: any;
  commissionTotal: any;
  amt: any;
  data: any;
  commissionList: any;
  recentReceiver: any;
  banktransferBeneficiaryForm: FormGroup;
  maxDate = new Date();

  currentUser: any;
  token: any;
  OptionList: any;
  UsertBal: any;
  serviceCode: any;
  OperatorName: any;
  Idprooflist: any;
  BeneficiaryTypelist: any;
  BeneficiaryRelationshiplist: any;
  countryISDCode: any;
  OtherRemarkslist: any;
  loadingspinner: boolean = false;

  public CountryFilterCtrl: FormControl = new FormControl();
  protected _onDestroy = new Subject<void>();
  public BankListFilterCtrl: FormControl = new FormControl();
  protected _onDestroy1 = new Subject<void>();

  BankList: any;
  IFSCode: any;
  purposeofremittancelist: any;
  senderSourceOfFundlist: any;
  senderOccupationlist: any;
  servicename: any;
  branchcodebangladeshLNlist: any;
  chnbankCode: any;
  maxchn: any;
  minchn: any;
  uniquecountrycode: any;


  constructor(private authService: AuthService, private router: Router,
    private route: ActivatedRoute, public dialog: MatDialog,
    private fb: FormBuilder, public datepipe: DatePipe,
    private toastr: ToastrService, private tokenStorageService: TokenStorageService, private tokenService: AuthenticationService,
    private _service: CommonService) {


    this.banktransferBeneficiaryForm = this.fb.group({
      beneficiary_type: [null, [Validators.required]],
      beneficiary_service_Accountcode: [null],
      beneficiary_country_Accountcode: [null, [Validators.required]],
      channel_Code: [null, [Validators.required]],
      beneficiary_fname: [null, [Validators.required, Validators.pattern("^[a-zA-Z ]*$")]],
      beneficiary_mname: [null, [Validators.pattern("^[a-zA-Z ]*$")]],
      beneficiary_lname: [null, [Validators.required, Validators.pattern("^[a-zA-Z ]*$")]],
      beneficiary_address: [null, [Validators.required]],
      beneficiary_state: [null],
      beneficiary_zipcode: [null],
      beneficiary_city: [null],
      //beneficiary_phone: [null, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(20), Validators.minLength(1)]],
      beneficiary_phone: [null],
      beneficiary_email: [null, [Validators.required, Validators.email]],
      beneficiary_relationship: [null, [Validators.required]],
      beneficiary_id_number: [null, [Validators.required, Validators.maxLength(100)]],
      beneficiary_Other_Remarks: [],
      beneficiary_account_no: [null, [Validators.required, Validators.pattern("^[0-9a-zA-Z]*$"), Validators.maxLength(50)]], // if mobilemon u haveto pass mobileno. -if bank then bank account no.-if ezipey wallet userid
      beneficiary_bank_code: [null],  // for bank code onli
      ReceiverDateofbirth: [null, [Validators.required]],
      ReceiverIdExpiryDate: [null, [Validators.required]],
      beneficiary_bank_name: [null],
      senderOccupation: [null],
      senderSourceOfFund: [null],
      purposeofremittance: [null, [Validators.required]],
      beneficiary_id: [null],
      beneficiary_idLI: [null],
      beneficiary_idMFS: [null],
      SourceofFund: [null]

    })

  }


  ngOnInit(): void {

    debugger
    this.token = this.tokenStorageService.getToken();
    this.serviceCode = this.route.snapshot.queryParams.serviceCode;
    //this.getstatsenderreceiveridtypelistLN();
    if (this.token) {
      this.currentUser = this.tokenStorageService.getUser();
      //this.UsertBal = this.tokenStorageService.getUsertBal();
      // this.getstatsenderreceiveridtypelistLN();//aus
      this.getcountryList();
      this.GetBeneficiaryRelationship();
      this.GetBeneficiaryType();
      this.getpurposeofremittancelistLN();
      //this.getIdprooflist();

      // listen for search field value changes
      this.CountryFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterCountry();
        });

      // listen for search field value changes
      this.BankListFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy1))
        .subscribe(() => {
          this.filterBankList();
        });

      //this.f.beneficiary_phone.valueChanges.subscribe(val => {

      //  if (val && val.length > 0 && this.countryISDCode == '86') {
      //    debugger;

      //    this.f.beneficiary_phone.setValue(null);
      //    this.f.beneficiary_phone.setValidators([
      //      Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(20), Validators.minLength(1)
      //    ]);
      //  }

      //});
    }
    else {
      this._service.callMethodOfSecondComponent();
    }
  }

  Back() {
    this.router.navigate(['/Transfertobank'], { queryParams: { serviceCode: this.serviceCode }, skipLocationChange: true });
  }

  get f() { return this.banktransferBeneficiaryForm.controls; }


  submitBankTransferBeneficiaryForm(post: any) {
    debugger
    this.submitted = true;
    if (this.banktransferBeneficiaryForm.valid) {
      this.loadingspinner = true;
      ////////console.log(post);
      // post.beneficiary_bank_code = '146';      
      // post.beneficiary_phone = this.countryISDCode + post.beneficiary_phone;


      if (this.chnbankCode == 2835 || this.chnbankCode == 2836 || this.chnbankCode == 2846 || this.chnbankCode == 2900 || this.chnbankCode == 2901 || this.chnbankCode == 2973 || this.chnbankCode == 2992 || this.chnbankCode == 3018 || this.chnbankCode == 3023 || this.chnbankCode == 3035 || this.chnbankCode == 3055 || this.chnbankCode == 3059 || this.chnbankCode == 3141 || this.chnbankCode == 3231 || this.chnbankCode == 3344 || this.chnbankCode == 3445) {  //for lightnet china select then hide mobileno

        post.beneficiary_phone = null;
      }
      else {
        post.beneficiary_phone = this.countryISDCode + post.beneficiary_phone;
      }
      post.beneficiary_service_Accountcode = this.serviceCode;
      post.beneficiary_nationality = post.beneficiary_country_Accountcode;

      //if (post.beneficiary_relationship == 'O') {  //onli in other case 
      //  post.beneficiary_relationship = post.beneficiary_Other_Remarks;
      //}

      var dt1 = this.datepipe.transform(this.f.ReceiverDateofbirth.value, 'yyyy-MM-dd');
      var dt2 = this.datepipe.transform(this.f.ReceiverIdExpiryDate.value, 'yyyy-MM-dd');

      post.ReceiverDateofbirth = dt1;
      post.ReceiverIdExpiryDate = dt2;
      post.channel_Code = post.channel_Code.toString();

      if (this.servicename == 'LI') {  //for lightnet
        post.beneficiary_id = post.beneficiary_idLI;
      }
      else {
        post.beneficiary_id = post.beneficiary_idMFS;
      }



      this.authService.submitbanktransferBeneficiary(post, this.currentUser.serviceid).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; transactionStatus: any }) => {

        this.loadingspinner = false;
        if (response.apiStatus == true) {
          this.submitted = false;
          this.toastr.success(response.apiMessage, 'Success');
          this.banktransferBeneficiaryForm.reset();
        }
        else {
          this.toastr.error(response.apiMessage, 'Error');
        }
      }, (err: any) => {
        this.loadingspinner = false;
        if (err.error instanceof Error) {

          this.toastr.error(err.error, 'Error');
        } else {

          this.toastr.error(err.error, 'Error');
        }
      }
      );
    }
  }



  getcountryList() {
    this.submitted = false;

    this.authService.getchannelList(this.serviceCode, this.currentUser.serviceid).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; }) => {
      debugger
      if (response.apiStatus == true) {
        this.OptionList = response.apiData;

      }
      else if (response.apiStatus == false) { //    "apiMessage": "user account is disable",
        this.toastr.warning(response.apiMessage, 'Warning');
        this._service.callMethodOfSecondComponent();
      }
      else {
        this.toastr.error(response.apiMessage, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );


  }




  GetBeneficiaryType() {
    this.authService.GetBeneficiaryType().subscribe(response => {
      if (response) {
        this.BeneficiaryTypelist = response;
      }
      else {
        this.toastr.error('Error', 'Error');
      }
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }

  GetBeneficiaryRelationship() {
    this.authService.GetBeneficiaryRelationship().subscribe(response => {
      if (response) {
        this.BeneficiaryRelationshiplist = response;
      }
      else {
        this.toastr.error('Error', 'Error');
      }
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }

  getIdprooflist() {

    this.authService.GetkycType().subscribe(response => {
      debugger
      if (response) {
        this.Idprooflist = response;
      }
      else {
        this.toastr.error('Error', 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }


  GetbanktransferBeneficiaryDetails(code: any) { //countri code
    debugger
    this.authService.GetbanktransferBeneficiaryDetails(code).subscribe(response => {
      debugger
      this.userorderdetailList = response;

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }


  CheckBeneficiaryRelationship(code: any) {

    this.f.beneficiary_Other_Remarks.setValue(null);

    if (code == 'O') {

      this.authService.GetBeneficiaryRelationshipList().subscribe(response => {
        ;
        this.OtherRemarkslist = response;

      }, (err: any) => {
        if (err.error instanceof Error) {
          this.toastr.error(err.error, 'Error');
        } else {
          this.toastr.error(err.error, 'Error');
        }
      }
      );
    }
    else {
      this.OtherRemarkslist = null;
    }
  }

  getBanklist(codeval: any, CountryVal: any, requestedService: any, uniquecountrycodeVal: any) {
    debugger
    this.countryISDCode = CountryVal;
      

    if (CountryVal == '91' || CountryVal == '81' || CountryVal == '92' || CountryVal == '880' || CountryVal == '1' || CountryVal == '61' || CountryVal == '55') {  //for beneficiary_bank_code

      this.f.beneficiary_bank_code.updateValueAndValidity();

    }
    else {
      //
      this.f.beneficiary_bank_code.setValue(null);
      this.f.beneficiary_bank_code.clearValidators();
      this.f.beneficiary_bank_code.updateValueAndValidity();
    }

    this.f.beneficiary_bank_code.setValue(null);



    if (this.countryISDCode == '55') {  //for lightnet Australi-a philipines

      this.f.SourceofFund.setValidators([
        Validators.required
      ]);
      this.f.SourceofFund.updateValueAndValidity();
    }
    else {
      //
      this.f.SourceofFund.setValue(null);
      this.f.SourceofFund.clearValidators();
      this.f.SourceofFund.updateValueAndValidity();
    }
    this.f.SourceofFund.setValue(null);
    this.uniquecountrycode = uniquecountrycodeVal;//for euro
    //if (CountryVal == '91') {  //for lightnet india
    //  this.IFSCode = true;
    //}
    //else { //for mfs
    //  this.IFSCode = false;

    //}

    //get detail
    this.GetbanktransferBeneficiaryDetails(codeval);
    debugger;
    this.servicename = requestedService;
    if (requestedService == 'LI') {  //for lightnet


      this.getsenderOccupationlistLN();
      this.getsenderreceiveridtypelistLN();
      this.getsenderSourceOfFundlistLN();

      this.f.senderOccupation.setValue(null);
      this.f.senderOccupation.setValidators([
        Validators.required
      ]);

      this.f.senderSourceOfFund.setValue(null);
      this.f.senderSourceOfFund.setValidators([
        Validators.required
      ]);

      this.f.beneficiary_idLI.setValue(null);
      this.f.beneficiary_idLI.setValidators([
        Validators.required
      ]);


      //
      this.f.beneficiary_idMFS.setValue(null);
      this.f.beneficiary_idMFS.clearValidators();
      this.f.beneficiary_idMFS.updateValueAndValidity();
    }
    else { //for mfs

      this.f.senderOccupation.setValue(null);
      this.f.senderOccupation.clearValidators();
      this.f.senderOccupation.updateValueAndValidity();

      this.f.senderSourceOfFund.setValue(null);
      this.f.senderSourceOfFund.clearValidators();
      this.f.senderSourceOfFund.updateValueAndValidity();

      this.f.beneficiary_idLI.setValue(null);
      this.f.beneficiary_idLI.clearValidators();
      this.f.beneficiary_idLI.updateValueAndValidity();


      this.getIdprooflist();
      this.f.beneficiary_idMFS.setValue(null);
      this.f.beneficiary_idMFS.setValidators([
        Validators.required
      ]);



    }


    this.authService.GetbankDetails(codeval).subscribe(response => {
      debugger
      this.BankList = response.apiData;
      
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    }
    );

  }

  getbankName(bankName: any, bankCode: any) {
    debugger
    this.f.beneficiary_bank_name.setValue(bankName);

    this.maxchn = 20;
    this.minchn = 1;
    this.f.beneficiary_phone.setValidators([
      Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(this.maxchn), Validators.minLength(this.minchn)
    ]);

    this.chnbankCode = null;
    if (this.countryISDCode == '880') {  //for lightnet india

      this.getbranchcodebangladeshLN(bankCode);

      //this.IFSCode = true;
    }
    debugger
    if (this.countryISDCode == '61' || this.countryISDCode == '63' || this.countryISDCode == '91'
      || this.countryISDCode == '62' || this.countryISDCode == '55' || this.countryISDCode == '1') {  //for lightnet Australi-a philipines -ind

      this.f.beneficiary_state.setValidators([
        Validators.required
      ]);
      this.f.beneficiary_state.updateValueAndValidity();

      if (this.countryISDCode == '61') {  //for lightnet Australi-a 
        this.f.beneficiary_city.setValidators([
          Validators.required
        ]);
        this.f.beneficiary_city.updateValueAndValidity();

        this.f.beneficiary_zipcode.setValidators([
          Validators.required
        ]);
        this.f.beneficiary_zipcode.updateValueAndValidity();

      }
    }
    else {

      this.f.beneficiary_state.setValue(null);
      this.f.beneficiary_state.clearValidators();
      this.f.beneficiary_state.updateValueAndValidity();

      if (this.countryISDCode == '61') {  //for lightnet Australi-a 
        this.f.beneficiary_city.setValue(null);
        this.f.beneficiary_city.clearValidators();
        this.f.beneficiary_city.updateValueAndValidity();

        this.f.beneficiary_zipcode.setValue(null);
        this.f.beneficiary_zipcode.clearValidators();
        this.f.beneficiary_zipcode.updateValueAndValidity();
      }

    }


    if (this.countryISDCode == '86') {  //for lightnet china
      if (bankCode == 2835 || bankCode == 2836 || bankCode == 2846 || bankCode == 2900 || bankCode == 2901 || bankCode == 2973 || bankCode == 2992 || bankCode == 3018 || bankCode == 3023 || bankCode == 3035 || bankCode == 3055 || bankCode == 3059 || bankCode == 3141 || bankCode == 3231 || bankCode == 3344 || bankCode == 3445) {  //for lightnet china select then hide mobileno

        this.chnbankCode = bankCode;

        this.f.beneficiary_phone.setValue(null);
        this.f.beneficiary_phone.clearValidators();
        this.f.beneficiary_phone.updateValueAndValidity();
      }
      else {
        this.maxchn = 11;
        this.minchn = 11;
        this.chnbankCode = null;
        this.f.beneficiary_phone.setValue(null);
        this.f.beneficiary_phone.setValidators([
          Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(this.maxchn), Validators.minLength(this.minchn)
        ]);
        this.f.beneficiary_phone.updateValueAndValidity();
      }
    }
  }


  getsenderOccupationlistLN() {

    this.authService.getsenderOccupationlistLN().subscribe(response => {

      this.senderOccupationlist = response.apiData.result.result;
      //console.log(JSON.stringify(this.senderOccupationlist));
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }


  getsenderSourceOfFundlistLN() {
    debugger
    this.authService.getsenderSourceOfFundlistLN().subscribe(response => {
      debugger

      this.senderSourceOfFundlist = response.apiData.result.result;

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }


  getpurposeofremittancelistLN() {

    this.authService.getpurposeofremittancelistLN().subscribe(response => {

      this.purposeofremittancelist = response.apiData.result.result;

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }

  getstatsenderreceiveridtypelistLN() {

    this.authService.getstatsenderreceiveridtypelistLN().subscribe(response => {
      //////console.log(response);
      //this.purposeofremittancelist = response.apiData.result.result;

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }



  getsenderreceiveridtypelistLN() {

    this.authService.getsenderreceiveridtypelistLN().subscribe(response => {

      this.Idprooflist = response.apiData.result.result;


    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }

  getbranchcodebangladeshLN(bankentryid: any) {
    debugger
    this.authService.getbranchcodebangladeshLN(bankentryid).subscribe(response => {
      debugger
      this.branchcodebangladeshLNlist = response.apiData;


    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }


  filterCountry() {
    if (this.CountryFilterCtrl.value) {
      return this.OptionList.payservices.filter((x: { name: string; }) => x.name.toLowerCase().startsWith(this.CountryFilterCtrl.value.toLowerCase()));
    } else {
      return this.OptionList?.payservices;
    }
  }




  filterBankList() {

    if (this.BankListFilterCtrl.value) {

      return this.BankList.filter((x: { bankName: string; }) => x.bankName.toLowerCase().startsWith(this.BankListFilterCtrl.value.toLowerCase()));
    } else {
      return this.BankList;
    }
  }


}
